import { MouseEvent } from 'react';

export const handleMobileFormCtaClick = (event: MouseEvent<HTMLElement>, isMobile: boolean, openEvent: string) => {
    if (!isMobile) return;

    event.preventDefault();
    window.dispatchEvent(new Event(openEvent));
};
